import {BBModel} from "../bb_model";

const memberPrePaidBookings = {
    query(member, params) {
        return new Promise((resolve, reject) => {
            if (!params) {
                params = {};
            }
            params.no_cache = true;
            if (!member.$has('pre_paid_bookings')) {
                reject('member does not have pre paid bookings');
            } else {
                member.$get('pre_paid_bookings', params).then((bookings) => {
                        let booking;
                        if (Array.isArray(bookings)) {
                            // pre paid bookings embedded in member
                            bookings = (() => {
                                const result = [];
                                for (booking of Array.from(bookings)) {
                                    result.push(new BBModel.PrePaidBooking(booking));
                                }
                                return result;
                            })();
                            return resolve(bookings);
                        } else {
                            params.no_cache = false;
                            return bookings.$get('pre_paid_bookings', params).then((bookings) => {
                                    bookings = (() => {
                                        const result1 = [];
                                        for (booking of Array.from(bookings)) {
                                            result1.push(new BBModel.PrePaidBooking(booking));
                                        }
                                        return result1;
                                    })();
                                    return resolve(bookings);
                                }
                            );
                        }
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    }
};


export {
    memberPrePaidBookings
}